function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Schoonmaak-App-beheer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Logging",
  transform: "translate(-179.000000, -228.000000)",
  fill: "#425cd4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Datepick-icon",
  transform: "translate(179.000000, 228.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4493531,12.7707125 L2.40622812,12.7707125 C1.80204062,12.7707125 1.31247812,12.2809312 1.31247812,11.6769625 L1.31247812,6.9213375 L12.5431031,6.9213375 L12.5431031,11.6769625 C12.5431031,12.2809312 12.0535406,12.7707125 11.4493531,12.7707125 Z M2.40841562,2.5244625 L3.19372812,2.5244625 L3.19372812,3.5175875 C3.19372812,3.8798375 3.48750938,4.1738375 3.84997812,4.1738375 C4.21244688,4.1738375 4.50622812,3.8798375 4.50622812,3.5175875 L4.50622812,2.5244625 L9.35154063,2.5244625 L9.35154063,3.5175875 C9.35154063,3.8798375 9.64532188,4.1738375 10.0077906,4.1738375 C10.3702594,4.1738375 10.6640406,3.8798375 10.6640406,3.5175875 L10.6640406,2.5244625 L11.4493531,2.5244625 C12.0535406,2.5244625 12.5431031,3.014025 12.5431031,3.6182125 L12.5431031,5.6088375 L1.31247812,5.6088375 L1.31247812,3.6182125 C1.31247812,3.014025 1.80204062,2.5244625 2.40622812,2.5244625 L2.40841562,2.5244625 Z M11.4493531,1.2119625 L10.6640406,1.2119625 L10.6640406,0.6563375 C10.6640406,0.29386875 10.3702594,8.75e-05 10.0077906,8.75e-05 C9.64532188,8.75e-05 9.35154063,0.29386875 9.35154063,0.6563375 L9.35154063,1.2119625 L4.50404063,1.2119625 L4.50404063,0.6563375 C4.50404063,0.29386875 4.21025937,8.75e-05 3.84779063,8.75e-05 C3.48532187,8.75e-05 3.19154063,0.29386875 3.19154063,0.6563375 L3.19154063,1.2119625 L2.40622812,1.2119625 C1.07732187,1.2119625 -2.1875e-05,2.2890875 -2.1875e-05,3.6182125 L-2.1875e-05,11.6769625 C-2.1875e-05,13.0058688 1.07732187,14.0832125 2.40622812,14.0832125 L11.4493531,14.0832125 C12.7782594,14.0832125 13.8556031,13.0058688 13.8556031,11.6769625 L13.8556031,3.6182125 C13.8556031,2.2890875 12.7782594,1.2119625 11.4493531,1.2119625 Z",
  id: "Fill-1"
}))));
function SvgDatepickIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "92CEDDA5-F409-4364-9B8E-5CBC7B481920") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepickIconBlue);
export default __webpack_public_path__ + "static/media/Datepick_icon_blue.10c2420f9e0017d94dab2cca19b9994e.svg";
export { ForwardRef as ReactComponent };